import styled from 'styled-components'
import { isMacApp } from 'utils/functions/electron'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${() => `calc(100vh - ${isMacApp() ? '2.8rem' : '0px'})`};
`
